const setLogo = async () => {
    const favicon = document.getElementById("favicon");
    const logo = '/logo/main.svg'
    const domain = process.env.REACT_APP_ENV !== "local" ? '' : `https://${process.env.REACT_APP_DOMAIN}`;
    const url = domain + logo;
    const logoFetched = await fetch(url)
    if (logoFetched.ok) favicon.href = url;
  }

  setLogo();